import React from 'react';
import { Trans } from 'react-i18next';

import { setCommonDependency } from '@debank/content-editor';
import { request, withHttp, getCurrentAddress } from '@/utils';
import { UserCard } from '@/components';
import { L2PayModal } from '@/components/L2PayModal';
import { GroupAvatar } from '@/components/GroupAvatar';
import { ChannelAvatar } from '@/components/ChannelAvatar';
import { PreviewCard } from '@/hooks/editor';

export const initEditorDependency = () =>
  setCommonDependency({
    api: {
      postUploadImage: (formData: FormData) =>
        request.post<{
          image: {
            id: string;
            raw: {
              oss_url: string;
              full_url: string;
            };
            resize: {
              oss_url: string;
              full_url: string;
            };
          };
        }>('/common/upload_image_v2', formData, {
          headers: {},
          timeout: Infinity,
        }),
      postPreviewCard: ({ url }: { url: string }) =>
        request.post<{ card: PreviewCard }>('/card/add', { url: withHttp(url!) }).then(
          res => res?.card,
          () => null,
        ),
      fetchTagSearch: ({ q }: { q: string }) => request.get(`/feed/tag/search`, { q }),
      fetchSuggestedMention: ({ q }: { q: string }) =>
        request.get(`/feed/suggested_mention`, { q }),
      fetchUserSearch: ({ q, is_addr }: { q: string; is_addr: 0 | 1 }) =>
        request.get(`/user/search_v3`, { q, is_addr }),
      getBadgeList: () => request.get('/badge/list'),
      getOfficialBadgeList: () => request.get('/official_badge/list', { is_all: 1 }),
      fetchAllGroupList: () => request.get('/user/groups'),
      getSuggestedChannelList: () => request.get('/channel/suggested_channels'),
      searchChannelList: ({ q }: { q: string }) => request.get('/channel/search', { q }),
      getFollowingChannelList: () =>
        request.get('/channel/following_channels', { user_id: getCurrentAddress() || '' }),
    },
    components: {
      UserCard,
      PayModal: L2PayModal,
      GroupAvatar,
      ChannelAvatar,
    },
    text: {
      payWithBalance: <Trans i18nKey="CreateStream.payL2Balance"></Trans>,
    },
    richtextEditorConfig: {},
  });
